import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';
import ConfirmationModal from '__components/Modals/ConfirmationModal';
import Select from '__components/Inputs/Select';

export const StyledModalText = styled(KizenTypography)`
  margin-bottom: 17px;
`;

export const StyledModal = styled(ConfirmationModal)`
  .modal-body {
    overflow: unset;
    padding-right: 15px;
  }
`;

export const StyledSelect = styled(Select)`
  text-align: start;
`;
